import React, { useEffect, useRef, memo } from "react";
import "./liveChart.scss";
function TradingViewWidget() {
  const container = useRef();
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "live-chart-script";
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
        {
          "symbols": [
            [
              "TVC:GOLD|1D|EUR"
            ],
            [
              "TVC:SILVER|1D|EUR"
            ],
            [
              "TVC:PLATINUM|1D|EUR"
            ],
            [
              "TVC:PALLADIUM|1D|EUR"
            ]
          ],
          "chartOnly": false,
          "width": "100%",
          "height": "430",
          "locale": "en",
          "colorTheme": "dark",
          "autosize": true,
          "showVolume": false,
          "showMA": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "Arial, sans-serif",
          "fontSize": "10",
          "noTimeScale": false,
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "chartType": "area",
          "backgroundColor": "rgba(7, 28, 74, 1)",
          "lineWidth": 2,
          "lineType": 0,
          "dateRanges": [
            "1d|1",
            "1m|30",
            "3m|60",
            "12m|1D",
            "60m|1W",
            "all|1M"
          ],
          "lineColor": "rgba(191, 133, 19, 1)",
          "topColor": "rgba(191, 133, 19, 1)",
          "bottomColor": "rgba(7, 28, 74, 1)",
          "dateFormat": "MMM dd, yyyy",
          "timeHoursFormat": "12-hours"
        }`;

    if (!document.getElementById("live-chart-script")) {
      container.current.appendChild(script);
    }
  }, []);

  return (
    <div className="section-graph">
      <div className={`section home-style`}>
        <div className={`section-content`}>
          <div className="tradingview-widget-container" ref={container}>
            <div className="tradingview-widget-container__widget"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(TradingViewWidget);
